/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OWGame,
    OWGameFromJSON,
    OWGameFromJSONTyped,
    OWGameToJSON,
    OWGameResponseAllOf,
    OWGameResponseAllOfFromJSON,
    OWGameResponseAllOfFromJSONTyped,
    OWGameResponseAllOfToJSON,
    OWGameSEO,
    OWGameSEOFromJSON,
    OWGameSEOFromJSONTyped,
    OWGameSEOToJSON,
    OWGameSteamData,
    OWGameSteamDataFromJSON,
    OWGameSteamDataFromJSONTyped,
    OWGameSteamDataToJSON,
    OWGameSteamMatch,
    OWGameSteamMatchFromJSON,
    OWGameSteamMatchFromJSONTyped,
    OWGameSteamMatchToJSON,
} from './';

/**
 * 
 * @export
 * @interface OWGameResponse
 */
export interface OWGameResponse extends OWGame {
    /**
     * 
     * @type {boolean}
     * @memberof OWGameResponse
     */
    hasUserStats?: boolean;
    /**
     * Steam App ID
     * @type {number}
     * @memberof OWGameResponse
     */
    steamAppId?: number;
    /**
     * SEO-friendly URL slug
     * @type {string}
     * @memberof OWGameResponse
     */
    slug?: string;
    /**
     * Whether time tracking is enabled
     * @type {boolean}
     * @memberof OWGameResponse
     */
    timeTrackedGame?: boolean;
    /**
     * 
     * @type {OWGameSEO}
     * @memberof OWGameResponse
     */
    seo?: OWGameSEO;
    /**
     * 
     * @type {OWGameSteamMatch}
     * @memberof OWGameResponse
     */
    steamMatch?: OWGameSteamMatch;
    /**
     * 
     * @type {OWGameSteamData}
     * @memberof OWGameResponse
     */
    steamData?: OWGameSteamData;
    /**
     * Generated Steam logo URL
     * @type {string}
     * @memberof OWGameResponse
     */
    steamLogoUrl?: string;
    /**
     * When Steam data was last refreshed
     * @type {Date}
     * @memberof OWGameResponse
     */
    steamDataLastRefreshed?: Date;
    /**
     * Steam news data
     * @type {{ [key: string]: object; }}
     * @memberof OWGameResponse
     */
    steamNews?: { [key: string]: object; };
}

export function OWGameResponseFromJSON(json: any): OWGameResponse {
    return OWGameResponseFromJSONTyped(json, false);
}

export function OWGameResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWGameResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...OWGameFromJSONTyped(json, ignoreDiscriminator),
        'hasUserStats': !exists(json, 'hasUserStats') ? undefined : json['hasUserStats'],
        'steamAppId': !exists(json, 'steamAppId') ? undefined : json['steamAppId'],
        'slug': !exists(json, 'slug') ? undefined : json['slug'],
        'timeTrackedGame': !exists(json, 'timeTrackedGame') ? undefined : json['timeTrackedGame'],
        'seo': !exists(json, 'seo') ? undefined : OWGameSEOFromJSON(json['seo']),
        'steamMatch': !exists(json, 'steamMatch') ? undefined : OWGameSteamMatchFromJSON(json['steamMatch']),
        'steamData': !exists(json, 'steamData') ? undefined : OWGameSteamDataFromJSON(json['steamData']),
        'steamLogoUrl': !exists(json, 'steamLogoUrl') ? undefined : json['steamLogoUrl'],
        'steamDataLastRefreshed': !exists(json, 'steamDataLastRefreshed') ? undefined : (new Date(json['steamDataLastRefreshed'])),
        'steamNews': !exists(json, 'steamNews') ? undefined : json['steamNews'],
    };
}

export function OWGameResponseToJSON(value?: OWGameResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...OWGameToJSON(value),
        'hasUserStats': value.hasUserStats,
        'steamAppId': value.steamAppId,
        'slug': value.slug,
        'timeTrackedGame': value.timeTrackedGame,
        'seo': OWGameSEOToJSON(value.seo),
        'steamMatch': OWGameSteamMatchToJSON(value.steamMatch),
        'steamData': OWGameSteamDataToJSON(value.steamData),
        'steamLogoUrl': value.steamLogoUrl,
        'steamDataLastRefreshed': value.steamDataLastRefreshed === undefined ? undefined : (value.steamDataLastRefreshed.toISOString()),
        'steamNews': value.steamNews,
    };
}


